module.exports = __webpack_public_path__ + "static/media/ats-exterior.fd5bb607.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/ats-exterior.jpg
// module id = 963
// module chunks = 0